import ReportStatisticCard from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import { MemberReportMessagesSentStatisticsCardFragment$key } from "@/admin/insights/member-reports/tabs/discussions/__generated__/MemberReportMessagesSentStatisticsCardFragment.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import { graphql, useFragment } from "react-relay"

interface Props {
  organizationMembershipKey: MemberReportMessagesSentStatisticsCardFragment$key
}

export default function MemberReportMessagesSentStatisticsCard({
  organizationMembershipKey,
}: Props) {
  const labels = useLabels()
  const organizationMembership =
    useFragment<MemberReportMessagesSentStatisticsCardFragment$key>(
      graphql`
        fragment MemberReportMessagesSentStatisticsCardFragment on OrganizationMembership
        @argumentDefinitions(startDate: { type: "String" }) {
          messagesSentReport: userActivityReport(
            startDate: $startDate
            kinds: [channel_message_sent]
            entities: [ChatChannel]
          ) {
            allTime
            sinceYesterday
          }
        }
      `,
      organizationMembershipKey
    )

  return (
    <ReportStatisticCard
      testid={"MemberReportMessagesSentStatisticCard"}
      value={organizationMembership.messagesSentReport?.allTime || 0}
      sinceYesterday={organizationMembership.messagesSentReport?.sinceYesterday || 0}
      subtitle={`Total Messages Sent`}
      tooltip={`The number of messages this ${labels.admin_member.singular} has sent to all channels since joining the ${labels.organization.singularLowercase}.`}
    />
  )
}
